import { Theme } from '@mui/material/styles'

const useStyles = {
  highlightColor: (theme: Theme) => ({
    color: theme.palette.primary.dark,
  }),
  highlightBold: {
    fontWeight: 600,
  },
  isDeactivatedText: {
    fontStyle: 'italic',
    textDecoration: 'line-through',
  },
  truncatedResult: {
    maxWidth: '230px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}

export default useStyles
